var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
export var DialogStateContext = React.createContext({
  openedDialogs: [],
  open: function () {},
  close: function () {}
});
var dialogReducer = function (state, action) {
  var dialogId = action.dialogId,
    isOpen = action.isOpen;
  if (isOpen) {
    if (state.includes(dialogId)) {
      return __spreadArray([], __read(state), false);
    } else {
      return __spreadArray(__spreadArray([], __read(state), false), [dialogId], false);
    }
  }
  return state.filter(function (openedDialogId) {
    return openedDialogId !== dialogId;
  });
};
/**
 * Internal context serving as the source of thruth for the dialogs that are opened
 * in the tree. Useful to keep the opened/closed state of dialogs in sync when there's
 * multiple usage of the same id.
 */
export var DialogStateProvider = function (_a) {
  var children = _a.children;
  var _b = __read(React.useReducer(dialogReducer, []), 2),
    openedDialogs = _b[0],
    dialogDispatch = _b[1];
  var open = React.useCallback(function (id) {
    dialogDispatch({
      dialogId: id,
      isOpen: true
    });
  }, [dialogDispatch]);
  var close = React.useCallback(function (id) {
    dialogDispatch({
      dialogId: id,
      isOpen: false
    });
  }, [dialogDispatch]);
  var result = React.useMemo(function () {
    return {
      openedDialogs: openedDialogs,
      open: open,
      close: close
    };
  }, [openedDialogs, open, close]);
  return React.createElement(DialogStateContext.Provider, {
    value: result
  }, children);
};